
export default function Author() {
  return (
<>  <section class="vs-blog-wrapper space-top space-extra-bottom">
    <div class="container">
      <div class="vs-sort-bar">
        <div class="row gap-4 align-items-center">
          <div class="col-md-auto flex-grow-1">
            <p class="woocommerce-result-count">Showing <span>1-9 of 40</span> results</p>
          </div>
          <div class="col-md-auto">
            <form class="woocommerce-ordering" method="get">
              <select name="orderby" class="orderby" aria-label="Shop order">
                <option value="recent_product" selected="selected">Short By Latest</option>
                <option value="popularity">Sort by popularity</option>
                <option value="rating">Sort by average rating</option>
                <option value="date">Sort by latest</option>
                <option value="price">Sort by price: low to high</option>
                <option value="price-desc">Sort by price: high to low</option>
              </select>
            </form>
          </div>
        </div>
      </div>
      <div class="row g-4">
        <div class="row g-4">
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.20s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-1.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Jessica Kalvin</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.30s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-2.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Rodja Heartmann</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.40s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-3.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Ema Watson</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.50s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-4.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Rivanur R. Rafi</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.60s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-5.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Mrthina Kaiko</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.70s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-6.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Alison Baker</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.20s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-7.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Branden Mc Calam </a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.30s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-8.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Fahim Al Bashar</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.40s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-9.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Ema Watson</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.50s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-10.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Allaudin Alim</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.60s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-11.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Gonza Hatun</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.70s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-12.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Dua Lipa</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.20s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-13.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Eva Green</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.30s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-14.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Josher Martha</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.40s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-15.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Jenifer Lopez</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.50s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-16.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Snow White</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.60s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-17.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Kauppila Bevan</a></h2>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-4 col-6 wow animate__fadeInUp" data-wow-delay="0.70s">
            <div class="feature-style2">
              <span class="feature-img">
              <img src="assets/img/feature/feature-author-1-8.jpg" alt="feature image"/>
            </span>
              <h2 class="feature-title"><a href="author-details.html">Tony Stark</a></h2>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center wow animate__fadeInUp" data-wow-delay="0.95s">
        <div class="col-auto">
          <div class="vs-pagination mt-55"><a href="#" class="pagi-btn"><i class="fa-solid fa-arrow-left"></i></a>
            <ul>
              <li><a href="#" class="active">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">...</a></li>
              <li><a href="#">16</a></li>
            </ul><a href="#" class="pagi-btn active"><i class="fa-solid fa-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-layout1 z-index-common blog-title">
    <div class="container">
      <div class="row gx-60 align-items-center">
        <div class="col-lg-3">
          <div class="cta-logo">
            <a href="index.html"><img src="assets/img/logo.svg" alt="Ebukz" class="logo"/></a>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row justify-content-xl-between justify-content-center align-items-center">
            <div class="col-xl-4 col-lg-5">
              <div class="newsletter-inner">
                <span class="newsletter-icon"><img src="assets/img/icons/mail-2.svg" alt="icon"/></span>
                <div class="newsletter-content">
                  <h4 class="newsletter_title">Get In Touch</h4>
                  <p class="newsletter-text">Subscribe for more Update</p>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-7">
              <div class="newsletter-form">
                <div class="search-btn">
                  <input class="form-control" type="email" placeholder="Your Email Address"/>
                  <button type="submit" class="vs-btn"><i class="fa-solid fa-paper-plane"></i> Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section></>
      );
}